export const get = () => {
    if (typeof window !== 'undefined' && window.ikea?.postalCode?.get) {
        return window.ikea.postalCode.get();
    }
    return Promise.reject();
};
